import { BigMath } from "@yn/utils";

export function calculatePositionMetrics(
    params: { cost: number | string; marketPrice: number | string; quantity: number | string },
) {
    const currentValue = Number( BigMath.times( params.marketPrice, params.quantity ) );
    const profit = Number( BigMath.minus( currentValue, params.cost ) );
    const profitPercent = BigMath.isZero( params.cost )
        ? 0
        : Number( BigMath.times( BigMath.div( profit, params.cost ), 100, 2 ) );

    return { currentValue, profit, profitPercent };
}
